import { useObserver } from "mobx-react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../store";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { useNavigate } from "react-router-dom";
import { MdOutlineWarning } from "react-icons/md";

export default function AlertPopup({ close = true }) {
  const { PopupStore } = useStores();
  const navigate = useNavigate();
  const closeThisPopUP = () => {
    PopupStore.setAlert(false);
  };

  return useObserver(() => {
    return (
      <>
        {PopupStore.alert && (
          <div
            onClick={closeThisPopUP}
            className="fixed w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black/30"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute inset-0 bg-white z-50 flex flex-col justify-center items-center md:w-[400px] w-[90%] h-fit m-auto rounded-2xl shadow-xl overflow-hidden"
            >
              <div className="flex flex-col w-full">
                {close && (
                  <button
                    onClick={closeThisPopUP}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <AiOutlineCloseCircle className="w-5 h-5" />
                  </button>
                )}

                <div className="p-8">
                  <div className="flex items-start gap-4">
                    {PopupStore.message.includes("login") ||
                    PopupStore.message.includes("signup") ||
                    PopupStore.message.includes("resumes") ? (
                      <div className="flex-shrink-0 p-2 bg-yellow-50 rounded-full">
                        <MdOutlineWarning className="text-yellow-500 text-2xl" />
                      </div>
                    ) : PopupStore.message.includes("Incorrect") ? (
                      <div className="flex-shrink-0 p-2 bg-red-50 rounded-full">
                        <MdOutlineWarning className="text-red-500 text-2xl" />
                      </div>
                    ) : PopupStore.message.includes("verification") ||
                      PopupStore.message.includes("Email sent successfully") ? (
                      <div className="flex-shrink-0 p-2 bg-green-50 rounded-full">
                        <IoCheckmarkCircleOutline className="text-green-600 text-2xl" />
                      </div>
                    ) : null}

                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        {PopupStore.title}
                      </h3>
                      <p className="text-gray-600">{PopupStore.message}</p>
                    </div>
                  </div>
                </div>

                <div className="px-8 py-6 bg-gray-50 border-t border-gray-100">
                  <div className="flex justify-end gap-3">
                    {PopupStore.message.includes("score") ||
                    PopupStore.message.includes("resumes") ? (
                      <PrimaryButton
                        onClick={() => {
                          PopupStore.setGetMoreCredits(true);
                          PopupStore.setAlert(false);
                        }}
                        buttonName="Get more credits"
                      />
                    ) : PopupStore.message.includes("login") ||
                      PopupStore.message.includes("log") ||
                      PopupStore.message.includes("signup") ? (
                      <PrimaryButton
                        onClick={() => {
                          if (
                            PopupStore.message.includes("login") ||
                            PopupStore.message.includes("log")
                          ) {
                            navigate("/");
                            closeThisPopUP();
                          } else {
                            navigate("/register");
                            closeThisPopUP();
                          }
                        }}
                        buttonName={
                          PopupStore.message.includes("login") ||
                          PopupStore.message.includes("log")
                            ? "Login"
                            : "Sign up"
                        }
                      />
                    ) : PopupStore.message.includes(
                        "No user found with these credentials"
                      ) ||
                      PopupStore.message.includes(
                        "No account with that email address"
                      ) ||
                      PopupStore.message.includes(
                        "Please enter a valid email"
                      ) ? (
                      <PrimaryButton
                        onClick={() => {
                          closeThisPopUP();
                          // navigate("/register");
                          window.location.href = `https://www.reaidy.io/signup`;
                        }}
                        buttonName="Register Now"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
